import { action } from 'easy-peasy';
import { IActionSetUpdatedBloodPressureReading } from '../types';

const setUpdatedBloodPressureReading: IActionSetUpdatedBloodPressureReading = action(
  (state, payload) => {
    state.items = state.items.map(item => {
      if (item.latestReadings.bloodPressure?.id === payload.id) {
        item.latestReadings.bloodPressure = payload;
      }

      return item;
    });
  },
);

export default setUpdatedBloodPressureReading;
